import router from "@/router";
/*import Vue from 'vue'*/
import CONSTANTS from "@/constants.js";
import axios from "axios";

//const AUTH_TOKEN = process.env.VUE_APP_THREEKIT_TOKEN;

const showroom = {
  namespaced: true,

  state: {
    breadCrumbs: [],
    loading: false,

    selectedCatalogs: null,
    showroomPath: 'school',
    selectedCatalogsProducts: [],
    selectedInstitution: null,
    selectedInstitutionName: "",
    selectedSchool: null,
    color_1: null,
    color_2: null,
    color_3: null,
    mascot: "",
    submascot: "ATHLETICS",
    player2dReady: false,

    catalogs: [],
    homeCatalogsIds: [],
    activeProductCatalogId: null,
    loadingCatalogs: false,
    homepageGender: ["men", "women"],

    /* customizations */
    //locationDecorations: [],
    customDecorationTextLoading: true,
    customDecorationText: null, //when the user changes the default text stamp for a graphic
    customDecorationGraphic: null,

    customSpiritwearTextLoading: true,
    customSpiritwearDecorationText: null,
    customSpiritwearDecorationSubText: null,
    customSpiritwearDecorationGraphic: null,

    decorationFill: null,
    decorationOutline: null,
    decorationFont: null,

    spiritwearDecorationFill: null,
    spiritwearDecorationOutline: null,
    spiritwearDecorationFont: null,

    showCustomizationsBox: false,
    customizationsHelpRead: false,
    customizationStep: "home",
    decorationBoxLoading: false,

    /* end customizations */
  },

  getters: {
    color1: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.color_1;
      });
    },

    color2: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.color_2;
      });
    },

    color3: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.color_3;
      });
    },

    getTeamName: (state) => {
      return state.mascot?.trim().length > 0
        ? state.mascot
        : state.selectedInstitutionName;
    },

    decorationFillColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.decorationFill;
      });
    },

    decorationOutlineColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.decorationOutline;
      });
    },

    spiritwearDecorationFillColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.spiritwearDecorationFill;
      });
    },

    spiritwearDecorationOutlineColor: (state) => {
      return CONSTANTS.COLORS.find((color) => {
        return color.id === state.spiritwearDecorationOutline;
      });
    },

    showroomColors: (_state, getters) => {
      return [getters.color1, getters.color2, getters.color3];
    },

    getSelectedCatalogsIds: (state) => {
      const selectedCatalogs = state.catalogs.filter(
        (catalog) => catalog.selected === true
      );
      const arrayOfIds = selectedCatalogs.map((catalog) => catalog.id);
      return selectedCatalogs.length > 0 ? arrayOfIds : [];
    },

    isCatalogLoaded: (state) => (id) => {
      const catalog = state.catalogs?.filter((catalog) => catalog.id == id)[0];
      return catalog.products?.length > 0;
    },

    /* Customizations */

    uniformDecoration: (_state) => {
      return (
        _state.customDecorationGraphic ??
        /*getters.uniformTextDecorationURL*/ _state.customDecorationText
      );
    },

    spiritwearDecoration: (_state) => {
      return (
        _state.customSpiritwearDecorationGraphic ??
        _state.customSpiritwearDecorationText
      );
    },

    hexToRGB: () => (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },

    dealerCode: () => {
      return router.currentRoute.params.dealer_code;
    },

    //get the location names for all the selected catalogs
    catalogLocations: (state) => {
      return state.catalogs?.length
        ? state.catalogs
            ?.filter((catalog) => catalog.selected === true)
            .map((catalog) => {
              return catalog.products.map((product) => {
                return product.threekit_layout;
              });
            })[0]
            ?.filter((v, i, a) => a.indexOf(v) == i)
        : [];
    },

    selectedCatalogsProducts: (state) => {
      return state.selectedCatalogsProducts
    }
  },

  actions: {
    async init({ state, commit, dispatch, rootState }) {
      commit("SET_LOADING", true);
      const dealerUrl = `${rootState.settings.endpoint}api/v2/dealer`;
      const accountid = router.currentRoute.params.dealer_code;

      if (!accountid) {
        alert("missing acc id");
        router.push("/404");
        return false;
      }
      let dealerResponse;
      try {
        dealerResponse = await axios.get(dealerUrl, {
          params: {
            code: accountid,
          },
        });

        await dispatch("threekit/initThreekitColors", null, { root: true });
      } catch (e) {
        router.push("/404");
      }

      commit("dealer/SET_DEALER", dealerResponse.data, { root: true });
      commit("SET_LOADING", false);

      const url = `${rootState.settings.endpoint}api/v2/catalogs`;
      try {
        if (!state.catalogs?.length) {
          const { data } = await axios.get(url);
          commit("SET_CATALOGS", data);
        }

        if (!window.threekitPlayer) {
          let threeKitScript = document.createElement("script");
          const url = `${process.env.VUE_APP_THREEKIT_ENDPOINT}/app/js/threekit-player.js`;
          threeKitScript.setAttribute("src", url);
          document.head.appendChild(threeKitScript);
        }
      } catch {
        console.log("error getting sports list");
      }
    },

    async updateCatalog({ state, commit }, newCatalog) {
      const updatedCatalogs = state.catalogs.map((catalog) => {
        if (newCatalog.id == catalog.id) {
          return newCatalog;
        } else {
          return catalog;
        }
      });
      commit("SET_CATALOGS", updatedCatalogs);

      //Save the changes in the db
      try {
        //await dispatch('saveUpdatedCatalogs')
      } catch (error) {
        throw new Error(error);
      }
    },

    async selectCatalog({ commit }, id) {
      commit("selectCatalog", id);
    },

    async saveUpdatedCatalogs({ rootState, state, getters }) {
      try {
        const actualPageIsTheHomepage =
          router.currentRoute.name === "Showroom Catalogue" ||
          router.currentRoute.name === "CatalogueWithTeamLink";
        const url = rootState.settings.endpoint + "/api/v2/team-link";

        const params = {
          id: state.team_link.id,
          catalog_ids: getters.getSelectedCatalogsIds,
        };

        let config = {
          headers: {
            Authorization: "Bearer " + rootState.settings.token,
          },
        };

        if (
          actualPageIsTheHomepage &&
          !state.isAnEmbeddedShowroom &&
          !getters["actionsPermissions/isProjectLocked"]
        ) {
          await axios.put(url, params, config);
        }
      } catch (error) {
        throw new Error(error);
      }
    },

    checkEmptyCatalogs({ state }) {
      if (!state.catalogs || !state.catalogs.length) {
        router.push(`/showrooms/${router.currentRoute.params.dealer_code}`);
      }
    },

    async getDecorationsForSelectedCatalogLayouts({ dispatch, state, commit, getters }) {
      if (/*getters.catalogLocations == null || */ !window.decorationsApi) {
        console.log('ignored cos in home')
        return false;
      }

      const filtersSelectedCatalogsProducts = getters.selectedCatalogsProducts.map((scp) => {
        const catName = scp.catalogName
        const selCatNames = state.selectedCatalogs.find((sc) => {
          return sc.name === catName
        })
        return selCatNames
      })

      const catalogLocations = filtersSelectedCatalogsProducts.length
        ? state.catalogs
            .map((catalog) => {
              return catalog.products.map((product) => {
                return product.threekit_layout;
              });
            })[0]
            ?.filter((v, i, a) => a.indexOf(v) == i)
        : [];

      const locations =
        catalogLocations?.filter((location) => {
          return location != null && location.length && location !== "588R";
        }) || [];

      console.log("filtersSelectedCatalogsProducts", filtersSelectedCatalogsProducts)
      console.log("locationsSSSSSSSSSSSS", locations, catalogLocations)

      let found = { Uniform: false };

      for (let index = 0; index < locations.length; index++) {
        //  await dispatch('threekit/initDecorationsConfiguration', null, { root: true })
        const locationName = locations[index];

        console.log("locationName SS", locationName);

        //returns whole config, so we can get the field "Type" which tells if location is uniform or spiritwear
        const locationConfiguration = await dispatch(
          "threekit/getConfigurationByLocationName",
          locationName,
          { root: true }
        );

        console.log("locationConfiguration SS", locationConfiguration);

        let configuration = await dispatch(
          "threekit/getUniformDecorationConfiguration",
          locationConfiguration,
          { root: true }
        );

        console.log("configuration", configuration);

        //updates graphic field from decoration canvas using the configurator for uniform/spiritwear
        if (configuration) {
            await dispatch(
              "project/update2DDecoration",
              { configuration, decorationType: locationConfiguration.Type },
              { root: true }
            );

          const locationDecoration = await dispatch(
            "threekit/getLocationSnapshot",
            {
              locationName,
              configuration,
              options: {
                width: 470,
                height: 588,
              },
            },
            { root: true }
          );

          commit(
            "project/updateCatalogLocationDecoration",
            {
              locationName,
              locationDecoration,
            },
            { root: true }
          );

          //We generate a thumbnail for uniform and spiritwear just once
          if (!found.Uniform) {
            await dispatch(`threekit/getUniformThumbnail`, locationName, {
              root: true,
            });
            found.Uniform = true;
          } else {
            console.log("not processing, already havev it");
          }
        }
      }
    },

    updateMascotAndColors({ commit, dispatch }, payload) {
      commit("UPDATE_MASCOT_AND_COLORS", payload);

      //dispatch('get2DDecorations')
      dispatch("getDecorationsForSelectedCatalogLayouts");
    },

    async getUniform2DDecoration({ dispatch, commit }) {
      commit("SET_FIELD", {
        field: "customDecorationTextLoading",
        value: true,
      });

      const uniformDecoration = await dispatch(
        "threekit/get2DDecorationSnapshot",
        {
          configuration: {
            //Name: getters.getTeamName ? getters.getTeamName : 'TEAM NAME'
            //Name Fill: assetId de ese color, igual para Outline
          },
          /*options: {
          width: 400,
          height: 50
        }*/
        },
        {
          root: true,
        }
      );
      commit("SET_UNIFORM_DECORATION_TEXT", uniformDecoration);

      commit("SET_FIELD", {
        field: "customDecorationTextLoading",
        value: false,
      });
    },

    set2dPlayerReady({ commit }) {
      commit("set2dPlayerReady")
    },

    /* homepage */
    async fetchSchools({ rootState }) {
      try {
        const url = rootState.settings.endpoint + "api/v2/schools";
        const options = {
          params: {
            query: this.schoolKeyword,
          },
        };
        const { data } = await axios.get(url, options);
        this.schoolsList = data.map((school) => school);
      } catch (error) {
        return error;
      } finally {
        this.loading = false;
      }
    },

    selectSchool({ commit }, payload) {
      commit("selectSchool", payload);
      commit("project/SET_UNIFORM_FILL_COLOR", payload?.school?.color_2, {
        root: true,
      });
      commit("project/SET_SPIRITWEAR_FILL_COLOR", payload?.school?.color_2, {
        root: true,
      });
      commit("project/SET_UNIFORM_OUTLINE_COLOR", payload?.school?.color_3, {
        root: true,
      });
      commit("project/SET_SPIRITWEAR_OUTLINE_COLOR", payload?.school?.color_3, {
        root: true,
      });

      if (payload?.mascot) {
        commit("project/SET_UNIFORM_MASCOT", payload.mascot, { root: true });
        commit("project/SET_SPIRITWEAR_MASCOT", payload.mascot, { root: true });
      }

      if (payload?.schoolGraphic) {
        //todo get actual field name
        commit("project/SET_CENTER_DECORATION", payload.schoolGraphic, {
          root: true,
        });
      }
    },

    selectInstitution({ commit }, payload) {
      commit("selectInstitution", payload);
    },

    selectInstitutionName({ commit }, payload) {
      commit("selectInstitutionName", payload);
    },

    resetCatalogsSelection({ commit }) {
      commit("RESET_CATALOGS_SELECTION");
    },

    setHomepageGender({ commit }, gender) {
      commit("SET_HOMEPAGE_GENDER", gender);
    },

    setSelectedCatalogs({ commit }, catalogs) {
      commit("SET_SELECTED_CATALOGS", catalogs);
    },

    setPath({commit}, path) {
      commit("SET_PATH", path)
    },

    /* end homepage */

    /* global */

    async updateShowroomColor({ commit, dispatch }, { colorId, colorKey, ignoreDecoration }) {
      //dispatch recalc decoration
      await commit("SET_SHOWROOM_COLOR", { colorId, colorKey });

      if (colorKey === "color_2" || colorKey === "color_3") {
        if (colorKey === "color_2") {
          commit("project/SET_UNIFORM_FILL_COLOR", colorId, { root: true });
          commit("project/SET_SPIRITWEAR_FILL_COLOR", colorId, { root: true });
        } else {
          commit("project/SET_UNIFORM_OUTLINE_COLOR", colorId, { root: true });
          commit("project/SET_SPIRITWEAR_OUTLINE_COLOR", colorId, {
            root: true,
          });
        }
        console.log("ignoreDecoration", ignoreDecoration)
        if (!ignoreDecoration) dispatch("getDecorationsForSelectedCatalogLayouts");
      }
    },

    toggleCustomizationBox({ commit }) {
      commit("TOGGLE_CUSTOMIZATION_BOX");
    },

    readCustomizationsHelp({ commit }) {
      commit("TOGGLE_CUSTOMIZATION_HELP");
    },

    setCustomizationBoxLoading({ commit }, bool) {
      commit("TOGGLE_CUSTOMIZATION_LOADING", bool);
    },

    setDefaultDecorations({ commit, getters }) {
      commit("SET_DEFAULT_DECORATIONS", {
        uniformDecoration: getters.uniformDecoration,
        spiritwearDecoration: getters.spiritwearDecoration,
      });
    },

    setBreadcrumbs({ commit }, payload) {
      commit("SET_BREADCRUMBS", payload);
    },

    setCustomizationStep({ commit }, payload) {
      commit("SET_CUSTOMIZATION_STEP", payload);
    },

    setUniformDecorationLoading({ commit }, bool) {
      commit("SET_UNIFORM_DECORATION_LOADING", bool);
    },

    setSpiritwearDecorationLoading({ commit }, bool) {
      commit("SET_SPIRITWEAR_DECORATION_LOADING", bool);
    },

    //Catalog
    async fetchProductsFromSelectedCatalogs({ rootState, state }) {
      const catalogs = state.selectedCatalogs.map((c) => {
        return c.name;
      });
      try {
        const url = rootState.settings.endpoint + "api/v2/get-catalog-products";
        const options = {
          params: {
            catalog: JSON.stringify(catalogs),
          },
        };
        const { data } = await axios.get(url, options);
        console.log("PRODUCTS", data);
      } catch (error) {
        return error;
      }
    },

    async fetchProductsFromCatalog({ rootState, commit }, catalogName) {
      try {
        const url =
          rootState.settings.endpoint + "api/v2/catalog/get-catalog-products";
        const options = {
          params: {
            catalog: catalogName,
          },
        };
        const { data } = await axios.get(url, options);
        console.log("PRODUCTS FROM CATALOG", catalogName, data);

        //UPDATE CATALOGS DATA ARRAY
        commit("APPEND_PRODUCTS_CATALOG", {
          products: data,
          catalogName,
        });
      } catch (error) {
        return error;
      }
    },

    /* single */

    moveToSingleProductPage() {
      router.push(
        `/showrooms/${router.currentRoute.params.dealer_code}/product`
      );
    },
  },

  mutations: {
    /* init */
    SET_CATALOGS(state, catalogs) {
      state.catalogs = catalogs;
    },

    SET_HOME_CATALOGS_IDS(state, homeCatalogsIds) {
      state.homeCatalogsIds = homeCatalogsIds;
    },

    SET_LOADING_CATALOGS(state, booleanState) {
      state.loadingCatalogs = booleanState;
    },

    SET_HOMEPAGE_GENDER(state, gender) {
      state.homepageGender = gender;
    },

    SET_SELECTED_CATALOGS(state, catalogs) {
      state.selectedCatalogs = catalogs;
    },

    SET_PATH(state, path) {
      state.showroomPath = path
    },

    SET_LOADING(state, booleanState) {
      state.loading = booleanState;
    },

    /* homepage */
    selectSchool: (state, payload) => {
      const fields = ["color_1", "color_2", "color_3", "mascot"];

      fields.forEach((field) => {
        state[field] = payload?.school ? payload.school[field] : null;
      });

      if (payload?.mascot) {
        state.mascot = payload.mascot;
      }

      state.decorationFill = payload?.school?.color_2;
      state.spiritwearDecorationFill = payload?.school?.color_2;
      state.decorationOutline = payload?.school?.color_3;
      state.spiritwearDecorationOutline = payload?.school?.color_3;

      state.selectedSchool = payload?.school;
    },

    selectInstitution: (state, value) => {
      state.selectedInstitution = value;
    },

    selectInstitutionName: (state, value) => {
      state.selectedInstitutionName = value;
    },

    /* end homepage */

    /* global */
    SET_FIELD(state, payload) {
      state[payload.field] = payload.value;
    },

    SET_SHOWROOM_COLOR(state, { colorId, colorKey }) {
      state[colorKey] = colorId;

      //Update decoration colors
      if (colorKey === "color_2") {
        state.decorationFill = colorId;
        state.spiritwearDecorationFill = colorId;
      } else if (colorKey === "color_3") {
        state.decorationOutline = colorId;
        state.spiritwearDecorationOutline = colorId;
      }
    },

    /*SELECT_CATALOG(state, sportId) {
      state.selectedCatalogs.push(sportId)
    },

    DESELECT_CATALOG(state, sportId) {
      state.selectedCatalogs = state.selectedCatalogs.filter((c) => {
        return c != sportId
      })
    },*/

    unselectCatalog: (state, id) => {
      state.catalogs.forEach((sport) => {
        if (sport.id == id) sport.selected = false;
      });
    },

    selectCatalog: (state, id) => {
      state.catalogs.forEach((sport) => {
        if (sport.id == id) sport.selected = !sport.selected;
      });
    },

    RESET_CATALOGS_SELECTION: (state) => {
      state.catalogs.forEach((sport) => {
        sport.selected = false;
      });
    },

    TOGGLE_CUSTOMIZATION_BOX: (state) => {
      state.showCustomizationsBox = !state.showCustomizationsBox;
    },

    TOGGLE_CUSTOMIZATION_HELP: (state) => {
      state.customizationsHelpRead = true;
    },

    TOGGLE_CUSTOMIZATION_LOADING: (state, bool) => {
      state.decorationBoxLoading = bool;
    },

    SET_DEFAULT_DECORATIONS: (state, payload) => {
      if (!state.customDecorationText)
        state.customDecorationText = payload.uniformDecoration;
      if (!state.customSpiritwearDecorationText)
        state.customSpiritwearDecorationText = payload.spiritwearDecoration;
    },

    SET_UNIFORM_DECORATION_TEXT: (state, payload) => {
      state.customDecorationText = payload;
    },

    SET_SPIRITWEAR_DECORATION_TEXT: (state, payload) => {
      state.customSpiritwearDecorationText = payload;
    },

    SET_BREADCRUMBS: (state, payload) => {
      state.breadCrumbs = payload;
    },

    SET_CUSTOMIZATION_STEP: (state, payload) => {
      state.customizationStep = payload;
    },

    SET_UNIFORM_DECORATION_LOADING: (state, bool) => {
      state.customDecorationTextLoading = bool;
    },

    SET_SPIRITWEAR_DECORATION_LOADING: (state, bool) => {
      state.customSpiritwearTextLoading = bool;
    },

    /*updateCatalogLocationDecoration: (state, payload) => {
      //search if we already have this location 
      let location = state.locationDecorations.find((l) => {
        return l.locationName === payload.locationName
      })

      const data = {
        locationName: payload.locationName,
        value: payload.locationDecoration,
        loading: false
      }

      if (!location?.locationName) {
        state.locationDecorations = [
          ...state.locationDecorations, data
        ]
      }
      else {
        //console.log('we already have this location data and we are going to update it with:', data)
        const index = state.locationDecorations.findIndex((l) => {
          return l.locationName === payload.locationName
        })
        state.locationDecorations[index].value = payload.locationDecoration
      }
    },*/

    //Updates mascot, colors and submascot, if present
    UPDATE_MASCOT_AND_COLORS: (state, payload) => {
      const fields = Object.keys(payload);
      for (let index = 0; index < fields.length; index++) {
        const fieldKey = fields[index];
        const field = payload[fieldKey];
        state[fieldKey] = field;
      }
    },

    set2dPlayerReady: (state) => {
      state.player2dReady = true
    },

    //Catalog

    APPEND_PRODUCTS_CATALOG: (state, payload) => {
      state.selectedCatalogsProducts = [
        ...state.selectedCatalogsProducts,
        payload,
      ];
    },
  },
};

export default showroom;
